import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://pos-api-g6qg.onrender.com/api', // Replace with your API's base URL
    // baseURL: 'http://127.0.0.1:8000/api',
    // baseURL: 'http://13.202.90.193:80/api'
    headers: {
        'Content-Type': 'application/json',
        // Add any other custom headers here
    },
});

// Request interceptor
axiosInstance.interceptors.request.use(
    config => {
        // Add auth token or any other logic before request is sent
        const token = localStorage.getItem('jwt');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        // Handle error responses globally
        if (error.response.status === 401) {
            // For example, handle unauthorized errors
            console.error('Unauthorized, logging out...');
            // Add logic to log out the user or redirect to login page
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
